/**
 * Copyright IBM Corp. 2022, 2026
 */

import classNames from 'classnames'
import { Link } from 'lib/i18n/routing'
import { Text } from '@hashicorp/mds-react/components'
import { type ProductLogoSetFieldsFragment } from 'types/dato'
import { ProductLogo } from 'components/materia/product-logo'
import { vercelSplit } from '@web/cms'
import s from './style.module.css'

const PRODUCT_LINK_MAP = {
	boundary: '/products/boundary',
	consul: '/products/consul',
	hcp: '/cloud',
	nomad: '/products/nomad',
	packer: '/products/packer',
	terraform: '/products/terraform',
	vault: '/products/vault',
	'vault-radar': '/products/vault/hcp-vault-radar',
	'vault-secrets': '/products/vault/hcp-vault-secrets',
	waypoint: '/products/waypoint',
}

const ProductLogoSet = ({
	eyebrow,
	isLinkSet,
	divider,
	products,
}: ProductLogoSetFieldsFragment) => {
	return (
		<div>
			{divider ? (
				<div
					className={classNames(s.divider, s[vercelSplit(divider)], {
						[s.hasEyebrow]: eyebrow,
					})}
				/>
			) : null}
			{eyebrow ? (
				<Text.Label color="faint" className={s.eyebrow}>
					{eyebrow}
				</Text.Label>
			) : null}
			<ul className={s.products}>
				{products.map(({ product }) => {
					const parsedProduct = vercelSplit(product)
					return (
						<li key={parsedProduct}>
							{/* 
								Don't render a link if a page doesn't exist.
								Consider removing this check once Vault Radar
								and Vault Secrets pages launch.
							*/}
							{isLinkSet && PRODUCT_LINK_MAP[parsedProduct] ? (
								<Link
									href={PRODUCT_LINK_MAP[parsedProduct]}
									className={s.productLink}
								>
									<ProductLogo product={parsedProduct} />
								</Link>
							) : (
								<div className={s.product}>
									<ProductLogo product={parsedProduct} />
								</div>
							)}
						</li>
					)
				})}
			</ul>
		</div>
	)
}

export default ProductLogoSet
